// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class CallWindow$Type extends MessageType {
    constructor() {
        super("CallWindow", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "day_of_week", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "start_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "window_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "maint_max", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.dayOfWeek = 0;
        message.startTime = "";
        message.endTime = "";
        message.windowCount = 0;
        message.createdAt = "";
        message.updatedAt = "";
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.label = "";
        message.departmentId = 0;
        message.maintMax = 0;
        message.eventTradeId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 day_of_week */ 2:
                    message.dayOfWeek = reader.int32();
                    break;
                case /* string start_time */ 3:
                    message.startTime = reader.string();
                    break;
                case /* string end_time */ 4:
                    message.endTime = reader.string();
                    break;
                case /* int32 window_count */ 5:
                    message.windowCount = reader.int32();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 7:
                    message.updatedAt = reader.string();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* string label */ 13:
                    message.label = reader.string();
                    break;
                case /* int32 department_id */ 14:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 maint_max */ 15:
                    message.maintMax = reader.int32();
                    break;
                case /* int32 event_trade_id */ 16:
                    message.eventTradeId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 day_of_week = 2; */
        if (message.dayOfWeek !== 0)
            writer.tag(2, WireType.Varint).int32(message.dayOfWeek);
        /* string start_time = 3; */
        if (message.startTime !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.startTime);
        /* string end_time = 4; */
        if (message.endTime !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.endTime);
        /* int32 window_count = 5; */
        if (message.windowCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.windowCount);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 7; */
        if (message.updatedAt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.updatedAt);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* string label = 13; */
        if (message.label !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.label);
        /* int32 department_id = 14; */
        if (message.departmentId !== 0)
            writer.tag(14, WireType.Varint).int32(message.departmentId);
        /* int32 maint_max = 15; */
        if (message.maintMax !== 0)
            writer.tag(15, WireType.Varint).int32(message.maintMax);
        /* int32 event_trade_id = 16; */
        if (message.eventTradeId !== 0)
            writer.tag(16, WireType.Varint).int32(message.eventTradeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindow
 */
export const CallWindow = new CallWindow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallWindowList$Type extends MessageType {
    constructor() {
        super("CallWindowList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallWindow },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CallWindow results */ 1:
                    message.results.push(CallWindow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated CallWindow results = 1; */
        for (let i = 0; i < message.results.length; i++)
            CallWindow.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallWindowList
 */
export const CallWindowList = new CallWindowList$Type();
/**
 * @generated ServiceType for protobuf service CallWindowService
 */
export const CallWindowService = new ServiceType("CallWindowService", [
    { name: "CreateCallWindow", options: {}, I: CallWindow, O: CallWindow },
    { name: "GetCallWindow", options: {}, I: CallWindow, O: CallWindow },
    { name: "BatchGetCallWindow", options: {}, I: CallWindow, O: CallWindowList },
    { name: "UpdateCallWindow", options: {}, I: CallWindow, O: CallWindow },
    { name: "DeleteCallWindow", options: {}, I: CallWindow, O: Empty }
]);
